module.exports = __webpack_public_path__ + "static/media/Fosilfri-klimapartner.786355ff.png";